/** todo: document this class */
export enum ComplementaryContentType {
  PDF = 1,
  URL = 2,
  EXCEL = 3,
}

/** todo: document this class */
export class ComplementaryContent {
  public name: string;
  public url: string;
  public typeCode: number;

  constructor(name = "", url = "", typeCode = NaN) {
    this.name = name;
    this.url = url;
    this.typeCode = typeCode;
  }
}
